/** admin/games — KEYS. */
export const adminGamesKeys = {
  all: () => ['admin', 'games'] as const,
  lists: () => [...adminGamesKeys.all(), 'list'] as const,
  list: (filters: Record<string, unknown>) => [...adminGamesKeys.lists(), filters] as const,
  /** Flat "all games" list used by selectors. */
  flat: () => [...adminGamesKeys.all(), 'flat'] as const,
};
